@if (priceSetting()) {
	<div class="d-flex justify-content-between align-items-center">
		<h5 class="d-flex align-items-center my-4 fw-bold">
			<i
				class="fa-solid activeSettingsIcon"
				[ngClass]="{
					'fa-sack-dollar': termIcon(),
					'fa-building-columns': groupIcon(),
					'fa-money-bill': productIcon(),
				}"
			></i>
			Aktywne ustawienie cennika dla wybranego terminu
		</h5>
		<button mat-button class="h-100 py-1" [disabled]="disableHTMLClose" [mat-dialog-close]="false" cdkFocusInitial>
			<i class="fs-3 fas fa-times"></i>
		</button>
	</div>
	<app-group-offer-price-setting
		[currency]="currency"
		[board]="board"
		[priceSetting]="priceSetting()"
		[(priceOption)]="priceOption"
		[(editable)]="editable"
		[(termData)]="data"
		(priceSettingId)="getPriceSettingId($event)"
		[(buttonnone)]="buttonnone"
	></app-group-offer-price-setting>
} @else {
	<mat-spinner></mat-spinner>
}
